import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { SubTitle } from '../../Classes/ClassForm/ClassForm.styles';
import { readOnlyLabelTableText } from '../../../constants/GlobalTexts';
import Header from "../../Bases/Header";
import { EditFormFields, EditForm, FormFieldRow } from "../../Bases/EditForm.styles";
import { InputWrapperMedium } from "../../../common/FormElementWrappers/FormElementWrappers.styles";
import ImageForm from "../../../components/ImageForm/ImageForm";
import Input from "../../../components/Input/Input";

const EditClassBase: FC = () => {
  const {
    classId: classIdParam,
    baseId: baseIdParam
  } = useParams<{ classId: string, baseId: string }>();
  const classId = +(classIdParam ?? '-1');
  const baseId = +(baseIdParam ?? '-1');

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Class-Base Table', to: '/tables/classbases' }}
            title={`View Class ${classId} | Base ${baseId}`}
        />
        <EditForm>
          <EditFormFields>
            <FormFieldRow>
              <InputWrapperMedium>
                <Input
                    label={"Class Number"}
                    id={'classNo'}
                    value={classId.toString()}
                    disabled
                />
              </InputWrapperMedium>
              <InputWrapperMedium>
                <Input
                    label={"Base Number"}
                    id={'baseNo'}
                    value={baseId.toString()}
                    disabled
                />
              </InputWrapperMedium>
            </FormFieldRow>
            <ImageForm
                attribute={'base'}
                resourceNo={[classId, baseId]}
            />
            <SubTitle>{readOnlyLabelTableText}</SubTitle>
          </EditFormFields>
        </EditForm>
      </>
  );
};

export default EditClassBase;